import React, { useMemo } from "react";

import { widgetUtils } from "./utils";

// Define types
type Variant = "bot" | "user";
type Theme = string;

interface WidgetTextProps {
  data: string | object;

  variant: Variant;
  theme: Theme;
  color: string;
}

const WidgetText: React.FC<WidgetTextProps> = ({
  data,
  variant,
  color,
  theme
}) => {
  const bubbleStyles = useMemo(
    () => ({
      backgroundColor:
        variant == "bot" ? widgetUtils.themeBackgroundMessage(theme) : color,
      color: variant === "bot" ? "black" : "white"
    }),
    [variant, color, theme]
  );

  const renderContent = () => {
    try {
      if (typeof data === "string") {
        return (
          <div className="markdown-container w-full overflow-x-auto">
            {data}
          </div>
        );
      }
      return JSON.stringify(data);
    } catch (error) {
      console.error("Error rendering content:", error);
      return "Error displaying content";
    }
  };

  return (
    <div
      className={`tw-w-full
       tw-shadow-md
       tw-p-4
        ${widgetUtils.bubbleBorderRadius(variant)}
        tw-break-words tw-overflow-x-auto      
      `}
      style={bubbleStyles}
    >
      {renderContent()}
    </div>
  );
};

export default React.memo(WidgetText);
